<template>
  <div>
    <BaseInput
      ref="numberBaseInput"
      :mask="numberMask"
      use-pattern="\D"
      inputmode="numeric"
      v-bind="{ ...$attrs, ...propsToApply }"
      v-on="$listeners"
    >
      <template
        v-for="(slotValue, slotName) in $slots"
        v-slot:[slotName]
      >
        <slot :name="slotName" />
      </template>
    </BaseInput>
  </div>
</template>

<script>
import BaseInput from './BaseInput.vue'

// teto tecnico do campo (AI-3558, D10): digitos alem do 30o sao cortados pela mascara
const NUMBER_MAX_LENGTH = 30

export default {
  name: 'NumberInput',
  components: { BaseInput },
  props: {
    ...BaseInput.props,
    isRequired: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      privateRules: [],
      numberMask: '#'.repeat(NUMBER_MAX_LENGTH)
    }
  },
  computed: {
    rulesOfProps() {
      const { rules } = this.$props

      return [...this.privateRules, ...rules]
    },
    propsToApply() {
      const { ...props } = this.$props

      Object.assign(props, {
        rules: this.rulesOfProps,
      })

      return props
    }
  },
  created() {
    // sem regra de "so digitos": a mascara limpa o que e digitado e o envio limpa o valor
    // (sendAsset); uma regra aqui reprovaria o valor legado com espaco ao abrir o editar
    if (this.isRequired) {
      this.privateRules.push(this.isValid)
    }
  },
  mounted() {
    // o BaseInput com mascara so copia o value no hook updated; ao editar um ativo existente
    // o campo abriria vazio sem este re-render
    this.$nextTick(() => {
      this.$refs.numberBaseInput.$forceUpdate()
    })
  },
  methods: {
    reset() {
      this.$refs.numberBaseInput.reset()
    }
  }
}
</script>

<style>

</style>
